import base from "/opt/buildhome/repo/images/play-large.svg?svg";
import { getResizer } from "svg-merge-attributes";
export default getResizer(base, "");